export default "__VITE_ASSET__BRrEguLc__"